import React, { FC } from "react";

import { Box, Stack, Typography, Button } from "@mui/material";

import { Colors } from "@theme/colors";

interface Props {
  header: string;
  subHeader: string;
  ctaLabel: string;
  ctaHref: string;
  place?: "sidebar" | "article";
  downloadThumbnail?: string;
}
const DownloadCTA: FC<Props> = ({
  header,
  subHeader,
  ctaLabel,
  ctaHref = "#",
  place = "article",
  downloadThumbnail = "",
}) => {
  return (
    <Box
      sx={{
        marginBottom: "24px",
      }}
    >
      <Box
        sx={{
          display: {
            xs: "block",
            md: place === "sidebar" ? "block" : "none",
          },
          height: "74px",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {downloadThumbnail.trim() !== "" && ctaHref !== "#" ? (
          <Box
            sx={{
              backgroundColor: "#D9D9D9",
              backgroundImage: `url("${downloadThumbnail}")` ?? "",
              backgroundSize: "cover",
              position: "absolute",
              width: "182px",
              height: "74px",
              bottom: "0px",
              left: "32px",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              zIndex: 2,
            }}
          >
            &nbsp;
          </Box>
        ) : (
          ""
        )}

        <Box
          sx={{
            background: "linear-gradient(270deg, #280273 0%, #551B76 100%)",
            height: "32px",
            position: "absolute",
            width: "100%",
            bottom: "0px",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            zIndex: 1,
          }}
        >
          &nbsp;
        </Box>
      </Box>

      <Stack
        sx={{
          position: "relative",
          width: "100%",
          padding: "32px",
          background: "linear-gradient(270deg, #FAEFFF 0%, #EAF9FF 100%)",
          flexDirection: {
            xs: "column",
            md: "row",
          },
          gap: "24px",
          borderRadius: "8px",
        }}
      >
        <Stack
          sx={{
            flexDirection: "column",
            gap: "24px",
          }}
        >
          <Typography
            variant="h2"
            sx={{
              color: Colors.HeadingText,
              fontSize: "28px",
            }}
          >
            {header}
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: "Inter",
              color: Colors.BodyText,
              fontSize: "18px",
              fontWeight: 400,
              lineHeight: "27px",
            }}
          >
            {subHeader}
          </Typography>

          <Button
            href={ctaHref}
            color="primary"
            variant="contained"
            target="_blank"
            sx={{
              display: "inline-block",
              borderRadius: "8px",
              fontSize: "16px",
              fontFamily: "Inter",
              height: "46px",
              paddingX: "20px",
              alignContent: "center",
              alignSelf: place === "sidebar" ? "center" : "flex-start",
            }}
            disableRipple
            disableFocusRipple
            disableElevation
          >
            {ctaLabel}
          </Button>
        </Stack>

        {downloadThumbnail.trim() !== "" && ctaHref !== "#" ? (
          <Box
            sx={{
              display: {
                xs: "none",
                md: place == "sidebar" ? "none" : "flex",
              },
              width: "260px",
              height: "190px",
              borderRadius: "8px",
              background: "linear-gradient(270deg, #280273 0%, #551B76 100%)",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                width: "182px",
                height: "109px",
                borderRadius: "8px",
                backgroundColor: "#D9D9D9",
                backgroundImage: `url("${downloadThumbnail}")` ?? "",
                backgroundSize: "cover",
              }}
            >
              &nbsp;
            </Box>
          </Box>
        ) : (
          ""
        )}
      </Stack>
    </Box>
  );
};

export default DownloadCTA;
